import React from 'react';
import {Col, Row ,Typography} from 'antd';
const { Title, Link, Paragraph } = Typography;
const bannerImage= "../../images/hero-banner.png";
const arrowImage= "../../images/btn-arrow.svg"
const Banner = ()=>(
<div className="banner">
<div className="container">
  <Row gutter={[50,50]}>
    <Col md={24} lg={11} xl={11} className="banner-left">
          <div className="banner-content">
          <Title className="sub-heading">Fee Delegation as a Service for <span>VeChain</span> Developers</Title>
          <Paragraph className="main-para">Stay in your technological comfort zone, just be good at what you already know</Paragraph>
            <div className="btn-group">
                <Link className="primary-btn" href="#">Get Started</Link>
                <Link className="secoundry-btn" href="#">Chat with us <span>{<img src={arrowImage} alt=""/>}</span></Link>
            </div>
          </div>
    </Col>
    <Col md={24} lg={12} xl={13} className="banner-right">
        <div className="banner-img">
          {<img src={bannerImage} alt=""/>}
        </div>
    </Col>
  </Row>
</div>
</div>
);
export default Banner;